"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _Vizualizer = _interopRequireDefault(require("./Vizualizer"));
var _VizualizerErrorMessage = _interopRequireDefault(require("./VizualizerErrorMessage"));
var Styled = _interopRequireWildcard(require("./index.styles"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VisualizerLiquidPixel = function VisualizerLiquidPixel(_ref) {
  var lpActive = _ref.lpActive,
    isMobile = _ref.isMobile,
    lpClassName = _ref.lpClassName,
    surroundLibrary = _ref.surroundLibrary,
    textureLoadedUpdatePath = _ref.textureLoadedUpdatePath,
    onError = _ref.onError,
    onLiquidPixelVisualizerLoadedSuccessfully = _ref.onLiquidPixelVisualizerLoadedSuccessfully,
    backupImage = _ref.backupImage,
    onBackupImgClick = _ref.onBackupImgClick,
    dragMessage = _ref.dragMessage,
    showDragIcon = _ref.showDragIcon,
    autoRotate = _ref.autoRotate,
    displayDragMessage = _ref.displayDragMessage,
    visualizerChoices = _ref.visualizerChoices,
    activeTab = _ref.activeTab,
    checkingValidTexture = _ref.checkingValidTexture,
    validTexture = _ref.validTexture;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visIsReady = _useState2[0],
    setVisIsReady = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    displayErrorMessage = _useState4[0],
    setDisplayErrorMessage = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    prevVisualizerChoices = _useState6[0],
    setPrevVisualizerChoices = _useState6[1];
  var vizError = function vizError() {
    onError();
    setDisplayErrorMessage(true);
  };
  (0, _react.useEffect)(function () {
    if (displayErrorMessage && !(0, _isEqual["default"])(visualizerChoices, prevVisualizerChoices)) {
      setDisplayErrorMessage(false);
    }
    setPrevVisualizerChoices(visualizerChoices);
  }, [visualizerChoices]);
  if (checkingValidTexture) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Styled.LoadingSkeleton, {
      // eslint-disable-next-line max-len
      src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDc1cHgiIGhlaWdodD0iNDc1cHgiIHZpZXdCb3g9IjAgMCA0NzUgNDc1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPlJlY3RhbmdsZTwvdGl0bGU+CiAgICA8ZyBpZD0iRGVza3RvcCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRlc2t0b3AtSEQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNDMuMDAwMDAwLCAtMjgzLjAwMDAwMCkiIGZpbGw9IiNFMERGRTEiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIyNDMiIHk9IjI4MyIgd2lkdGg9IjQ3NSIgaGVpZ2h0PSI0NzUiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==",
      alt: "",
      className: "pip-components__Visualizer--image-main"
    }));
  }
  if (!validTexture) {
    return /*#__PURE__*/_react["default"].createElement(_VizualizerErrorMessage["default"], {
      isMobile: isMobile,
      onBackupImgClick: onBackupImgClick,
      backupImage: backupImage
    });
  }
  if (displayErrorMessage && !!backupImage) {
    return /*#__PURE__*/_react["default"].createElement(_VizualizerErrorMessage["default"], {
      isMobile: isMobile,
      onBackupImgClick: onBackupImgClick,
      backupImage: backupImage
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_Vizualizer["default"], {
    lpActive: lpActive,
    isMobile: isMobile,
    lpClassName: lpClassName,
    surroundLibrary: surroundLibrary,
    textureLoadedUpdatePath: textureLoadedUpdatePath,
    onError: vizError,
    onLiquidPixelVisualizerLoadedSuccessfully: onLiquidPixelVisualizerLoadedSuccessfully,
    backupImage: backupImage,
    onBackupImgClick: onBackupImgClick,
    dragMessage: dragMessage,
    showDragIcon: showDragIcon,
    autoRotate: autoRotate,
    displayDragMessage: displayDragMessage,
    visualizerChoices: visualizerChoices,
    visIsReady: visIsReady,
    setVisIsReady: setVisIsReady,
    activeTab: activeTab
  });
};
VisualizerLiquidPixel.propTypes = {
  lpActive: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool,
  lpClassName: _propTypes["default"].string,
  surroundLibrary: _propTypes["default"].string,
  textureLoadedUpdatePath: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onLiquidPixelVisualizerLoadedSuccessfully: _propTypes["default"].func,
  backupImage: _propTypes["default"].string,
  onBackupImgClick: _propTypes["default"].func,
  dragMessage: _propTypes["default"].string,
  showDragIcon: _propTypes["default"].bool,
  autoRotate: _propTypes["default"].bool,
  displayDragMessage: _propTypes["default"].bool,
  visualizerChoices: _propTypes["default"].object,
  activeTab: _propTypes["default"].string,
  checkingValidTexture: _propTypes["default"].bool.isRequired,
  validTexture: _propTypes["default"].bool
};
VisualizerLiquidPixel.defaultProps = {
  lpActive: false,
  isMobile: false,
  lpClassName: 'surroundViewer',
  surroundLibrary: 'https://homedepot.liquifire.com/zap/dhtml/com.liquidpixels.Surround.jsr',
  textureLoadedUpdatePath: _noop["default"],
  onError: _noop["default"],
  onLiquidPixelVisualizerLoadedSuccessfully: _noop["default"],
  backupImage: undefined,
  onBackupImgClick: _noop["default"],
  dragMessage: 'Drag to Spin',
  showDragIcon: true,
  autoRotate: false,
  displayDragMessage: true,
  visualizerChoices: undefined,
  activeTab: '',
  validTexture: true
};
var _default = VisualizerLiquidPixel;
exports["default"] = _default;
//# sourceMappingURL=index.js.map